import { getKeys } from './getKeys'

export const procedureTranslations = {
  // Page Header
  PROCEDURES: 'Procedures',
  PROCEDURES_FOR: "{{name}}'s Procedures",
  ADD_PROCEDURE: 'Add Procedure',
  PROCEDURES_TOOLTIP:
    'Record clinical or care procedures carried out, including any follow-up actions or interventions required.',

  // Modal
  PROCEDURE_RECORD: 'Procedure record',
  TITLE: 'Title',
  TITLE_REQUIRED: 'Title is required',
  TITLE_PLACEHOLDER: 'Enter procedure title',
  DESCRIPTION_OF_PROCEDURE: 'Description of procedure',
  DESCRIPTION_PLACEHOLDER: 'Enter procedure description (optional)',
  DATE_OF_PROCEDURE: 'Date of procedure',
  DATE_TIME_PLACEHOLDER: 'Select date and time',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  ADD: 'Add',

  // List
  NO_PROCEDURES_FOUND: 'No procedures found',
  NO_PROCEDURES_DESCRIPTION:
    'There are no procedures recorded for this resident yet.',
  NO_DATE_TIME_SPECIFIED: 'No date/time specified',
  ARCHIVED_PROCEDURES: 'Archived Procedures',

  // Actions
  VIEW: 'View',
  EDIT: 'Edit',
  ARCHIVE: 'Archive',
  ARCHIVED: 'Archived',
  ACTIVE: 'Active',
  UN_ARCHIVE: 'Un-archive',
  RESTORE: 'Restore',
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',
  CREATED_BY: 'Created by',
  UPDATED_BY: 'Updated by',

  // Archive Modal
  ARCHIVE_PROCEDURE: 'Archive Procedure',
  RESTORE_PROCEDURE: 'Restore Procedure',
  ARCHIVE_CONFIRMATION:
    'Are you sure you want to archive this procedure? You can restore it later if needed.',
  RESTORE_CONFIRMATION:
    'Are you sure you want to restore this procedure to active status?'
}

export const procedureConstants = getKeys(procedureTranslations)
